import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { CustomerOrdersApiAdapter } from '../adapters/CustomerOrdersApiAdapter';

export const useCustomerOrders = (customerIds: number[] | undefined) => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new CustomerOrdersApiAdapter(httpClient);

  const {
    data,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['customer-orders', customerIds],
    queryFn: () => {
      if (!customerIds || customerIds.length === 0) {
        return Promise.resolve({ data: [], meta: { currentPage: 1, lastPage: 1, total: 0 } });
      }
      return apiAdapter.getOrdersByCustomerIds(customerIds);
    },
    enabled: !!customerIds && customerIds.length > 0,
    staleTime: 30 * 1000, // 30 segundos
  });

  return {
    orders: data?.data || [],
    isLoading,
    error,
    refetch,
    total: data?.meta?.total || 0,
  };
};


